<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.displayName }}</p>
      <!-- <small>Available</small> -->
        <small class="text-success">활동중</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <!-- <img v-if="activeUserInfo.photoURL" key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" /> -->
        <img key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/space').catch(() => {})">
            <feather-icon icon="HomeIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">모든 클래스</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="goTimeTable()">
            <feather-icon icon="ClockIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">강의 시간표</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="goCalendar()">
            <feather-icon icon="CalendarIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">캘린더</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/mypage/main').catch(() => {})">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">프로파일</span>
          </li>
          <li v-if="adminState == true && activeUserInfo.level != 11"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/etest').catch(() => {})">
            <feather-icon icon="BookIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">시험 관리</span>
          </li>
          <li v-if="superAdminState == true && activeUserInfo.level != 11"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/admin/etest-form').catch(() => {})">
            <feather-icon icon="ListIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">시험 일정</span>
          </li>
          <li v-if="superAdminState == true || activeUserInfo.level != 11"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="goCollege()">
            <feather-icon icon="BookOpenIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">대학 관리</span>
          </li>
          <li v-if="superAdminState == true || activeUserInfo.level == 11"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="goPractice()">
            <feather-icon icon="BookIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">유형별 관리</span>
          </li>
          <li v-if="superAdminState == true || activeUserInfo.level == 11"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/admin/user-search').catch(() => {})">
            <feather-icon icon="ListIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">사용자 관리</span>
          </li>
          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/views/apps/mypage/Mypage.vue').catch(() => {})">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2 text-danger">Mypage</span>
          </li> -->

          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/chat').catch(() => {})">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/eCommerce/wish-list').catch(() => {})">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span>
          </li> -->

          <vs-divider class="m-1" />
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2 text-danger">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data() {
    return {
      adminState : this.$acl.check('admin'),
      superAdminState : this.$acl.check('superAdmin')
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    logout() {

        // if user is logged in via auth0
        if (this.$auth.profile) this.$auth.logOut();

        // if user is logged in via firebase
        const firebaseCurrentUser = firebase.auth().currentUser

        if (firebaseCurrentUser) {
            firebase.auth().signOut().then(() => {
                this.$router.push('/pages/login').catch(() => {})
            })
        }

        localStorage.removeItem('filleduToken')
        localStorage.removeItem('userInfo')
        sessionStorage.removeItem('filleduToken')
        sessionStorage.removeItem('userInfo')

        // Change role on logout. Same value as initialRole of acj.js
        this.$acl.change('public')
        // This is just for demo Purpose. If user clicks on logout -> redirect
        this.$router.push('/pages/login').catch(() => {})
    },
    goTimeTable(){
      this.$router.push('/apps/timetable/'+this.activeUserInfo.uid)
    },
    goCalendar(){
      this.$router.push('/apps/mypage/calendar/'+this.activeUserInfo.uid)
    },
    goPractice(){
      this.$router.push('/apps/epractice').catch(() => {})
    },
    goCollege() {
      this.$router.push('/apps/admin/college-form')
    },
  },
  created(){
    console.log(this.activeUserInfo)
  }
}
</script>
